import React from 'react';
import {
  SaveButton,
  UPDATE,
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';

import dataProvider from '../../core/providers/IccUserDataProvider';
import FundInvestorForm from './FundInvestorForm';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import FundInvestorApi from '../../core/apis/FundInvestorApi';
import { getIcError } from '../../core/providers/utils';

class FundInvestorCreateUpdate extends React.Component {
  fundInvestorFormProps;

  state = {
    submitting: false
  };

  setFundInvestorFormProps = props => {
    this.fundInvestorFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.fundInvestorFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.fundInvestorFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      operation,
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      refreshView
    } = this.props;

    this.setState({ submitting: true });

    // Prepare the list of fundinvestors to create
    const fundinvestors = [];
    if (operation === 'Create') {
      if (values.fundId) {
        values.investors.forEach(investorId => {
          fundinvestors.push({
            fundId: values.fundId,
            investorId
          });
        });
      } else {
        values.funds.forEach(fundId => {
          fundinvestors.push({
            fundId,
            investorId: values.investorId
          });
        });
      }
    }

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    // As we want to know when the new fundinvestors has been created/updated in order to close the modal, we use the
    // dataProvider directly to update, and async api call to create many
    const crudOperation =
      operation === 'Create'
        ? FundInvestorApi.create(fundinvestors)
        : dataProvider(UPDATE, 'fundinvestors', {
            data: { fundId: values.fundId, investorId: values.investorId }
          });

    crudOperation
      .then(() => {
        refreshView();
        handleDialogToggle();
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.fundInvestorFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const { operation, showDialog, fundId } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`${operation} fund investor`}
        maxWidth="md"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          {operation === 'Create'
            ? fundId
              ? 'Add Existing Investor to Fund'
              : 'Add Existing Fund to Investor'
            : operation + ' fund investor'}
        </DialogTitleWithCloseButton>
        <DialogContent>
          <FundInvestorForm
            {...this.props}
            setFundInvestorFormProps={this.setFundInvestorFormProps}
            handleSubmit={this.handleSubmit}
          />
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label={operation === 'Create' ? 'Add' : operation}
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(null, mapDispatchToProps)(FundInvestorCreateUpdate);
